export default {
  configDetails: {
    mediaDataTitle: {
      notes:
        'Title of the upper panel on the edit configuration page, showing the configured screening media (the lower panel is titled "Wear data")',
      message: 'Media data',
    },
    selectionDetails: {
      header: {
        notes:
          'Header for the selection details pane on the config details page',
        message: 'Selection details',
      },
    },
    parentConfigName: {
      notes:
        'Label for the parent configuration shown beside the current configuration on the edit page',
      message: '{{name}} (parent)',
    },
    currentConfigName: {
      notes:
        'Label for the current configuration shown beside its parent on the edit page',
      message: '{{name}} (this configuration)',
    },
    currentConfigDesignator: {
      notes:
        'Designator for the current configuration in the selection details comparison',
      message: 'This configuration',
    },
    parentDesignator: {
      notes:
        'Designator for the parent configuration in the selection details comparison',
      message: 'Parent',
    },
  },
  configList: {
    header: {
      notes: 'Header for Deck configuration page',
      message: 'Deck configuration',
    },
    addConfiguration: {
      notes: 'Button label for adding a new deck configuration',
      message: 'Add configuration',
    },
    newConfigurationName: {
      notes: 'Default name for a new deck configuration',
      message: 'New configuration',
    },
    copyConfigurationName: {
      notes: 'Name for a duplicated deck configuration',
      message: 'Copy of {{name}}',
    },
    duplicateDialogTitle: {
      notes: 'Title of the dialog for duplicating a deck configuration',
      message: 'Duplicate configuration',
    },
    nameAlreadyInUse: {
      notes:
        'Validation error shown when a deck configuration name is already used on the deck',
      message: 'A configuration with this name already exists',
    },
  },
  equipmentDetails: {
    header: {
      notes: 'Header for accordion section Deck configuration for screens',
      message: 'Deck configuration',
      open: {
        notes: 'Open detailed deck configuration',
        message: 'Open',
      },
    },
    open: {
      notes: 'Open detailed deck configuration',
      message: 'Open deck configuration',
    },
  },
};
